var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye2(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1703_47257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 20.1943C30.8939 20.1943 13.5676 30.6474 0.782449 47.6261C-0.260816 49.0171 -0.260816 50.9604 0.782449 52.3514C13.5676 69.3505 30.8939 79.8036 50 79.8036C69.1061 79.8036 86.4324 69.3505 99.2175 52.3719C100.261 50.9809 100.261 49.0375 99.2175 47.6465C86.4324 30.6474 69.1061 20.1943 50 20.1943ZM51.3706 70.987C38.6877 71.7848 28.2142 61.3317 29.012 48.6284C29.6666 38.1549 38.1559 29.6655 48.6294 29.0109C61.3123 28.2132 71.7858 38.6663 70.988 51.3695C70.313 61.8226 61.8237 70.312 51.3706 70.987ZM50.7364 61.2908C43.9041 61.7204 38.2582 56.0949 38.7082 49.2626C39.0559 43.6167 43.6381 39.0549 49.284 38.6867C56.1164 38.2571 61.7623 43.8826 61.3123 50.7149C60.9441 56.3813 56.3619 60.943 50.7364 61.2908Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1703_47257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye2);
export default __webpack_public_path__ + "static/media/Eye_2.25a5663de154da28242ccab0c019c606.svg";
export { ForwardRef as ReactComponent };